import { render, staticRenderFns } from "./RegisterUserForm.vue?vue&type=template&id=c31ec5cc&scoped=true"
import script from "./RegisterUserForm.vue?vue&type=script&lang=js"
export * from "./RegisterUserForm.vue?vue&type=script&lang=js"
import style0 from "./RegisterUserForm.vue?vue&type=style&index=0&id=c31ec5cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31ec5cc",
  null
  
)

export default component.exports